// KS1 Student Book — Tiny Steps (Ages 5–7)
// Phase 2 launch: 3 starter chapters at low-reading age. Read-aloud
// + simple activity. Full 12-chapter expansion to follow.

export const META = {
  series: "Ambedkarite Buddhist Educational Series — UK Edition",
  title: "Tiny Steps · Key Stage 1",
  subtitle: "Ages 5–7 · Big-hearted stories about kindness, fairness and brave first choices",
  edition: "Phase 2 · Sample Edition · 2026",
  status: "3 chapters published · 9 more in development",
};

export const CHAPTERS = [
  {
    n: 1,
    title: "Sharing the Last Apple",
    bigIdea: "When we share, we make a small thing into a big kindness.",
    storyTitle: "Anaya, Tom and the Last Apple",
    story: [
      "It was Friday and the snack bowl was nearly empty.",
      "There was only <strong>one apple</strong> left.",
      "Anaya saw it. Tom saw it. They both reached at the same time.",
      "Anaya stopped. She remembered what her grandma had said: <em>'A little kindness makes a big day.'</em>",
      "Anaya picked up the apple, looked at Tom, and asked Mrs. Hart for a knife.",
      "She cut the apple into two neat halves and gave one to Tom.",
      "Tom said, '<strong>Thank you, Anaya.</strong>'",
      "They munched their apple halves together by the window, and it tasted like the best apple ever.",
    ],
    activityTitle: "Our Sharing Wheel",
    activity: [
      "Sit in a small circle.",
      "Pass round a soft toy — a 'kindness bear'.",
      "Whoever holds the bear says <strong>one</strong> small kind thing they could do today.",
      "Say <strong>thank you</strong> after each one — together.",
    ],
    talkPrompts: [
      "How did Anaya make Tom feel?",
      "When is it hard to share?",
      "Who shares something with you at home?",
    ],
  },
  {
    n: 2,
    title: "The Boy Who Wanted to Learn",
    bigIdea: "Reading and learning are gifts every child deserves.",
    storyTitle: "A Boy Called Bhim",
    story: [
      "A long time ago, in a small Indian village, there was a clever boy called <strong>Bhim</strong>.",
      "Bhim loved school. He loved books most of all.",
      "But some children would not sit next to him. Some teachers would not write his name on the board.",
      "It made Bhim's heart feel small and sad.",
      "Bhim's father told him, '<strong>Learn, my son. Learning is the strongest thing in the world.</strong>'",
      "So Bhim read by the lamplight. He read on the way to school. He even read while he walked home.",
      "Bhim grew up to be <strong>Dr. B. R. Ambedkar</strong> — the man who wrote the rules of equality for a whole country, so that every child could learn together.",
    ],
    activityTitle: "Library Treasure Hunt",
    activity: [
      "Walk around the classroom.",
      "Find <strong>three</strong> books you have never read.",
      "Open each one and look at the pictures.",
      "Tell a friend one new word you saw.",
    ],
    talkPrompts: [
      "How would you feel if someone said you couldn't read books?",
      "What is your favourite book?",
      "Why do you think Bhim's dad said learning was strong?",
    ],
  },
  {
    n: 3,
    title: "Brave Like a Bee",
    bigIdea: "Being brave can be quiet — like a bee doing its little job.",
    storyTitle: "Layla's Little Brave Thing",
    story: [
      "Layla was new at school.",
      "At lunchtime she saw a girl called Mia sitting alone, drawing in a notebook.",
      "Layla's tummy felt fluttery. She did not know what to say.",
      "But she remembered the bees in her grandma's garden — small bees, doing their little jobs, even when the wind blew.",
      "Layla took a deep breath. She walked over and said, '<strong>Can I sit here?</strong>'",
      "Mia smiled big and slid her notebook so they could draw together.",
      "Layla had done one tiny brave thing — and it made the whole afternoon bright.",
    ],
    activityTitle: "My Tiny Brave Thing",
    activity: [
      "On a sticky note, draw <strong>one</strong> thing you could be brave about this week.",
      "It can be very small — saying hello, putting up your hand, trying a new food.",
      "Put your note on the class 'Brave Wall'.",
      "Look at the wall together at the end of the week.",
    ],
    talkPrompts: [
      "Is being brave the same as not being scared?",
      "When did someone help YOU feel less alone?",
      "What does a 'tiny brave thing' look like at home?",
    ],
  },
];
